export default {
    formId: 'servicesIaForm',
    formField: {
        provider: {
            name: 'provider',
            label: 'Proveedor IA',
            requiredErrorMsg: 'El proveedor es requerido'
        },
        serviceType: {
            name: 'serviceType',
            label: 'Tipo de Servicio',
            requiredErrorMsg: 'El tipo de servicio es requerido'
        },
        name: {
            name: 'name',
            label: 'Nombre Comercial',
            requiredErrorMsg: 'El nombre es requerido'
        },
        code: {
            name: 'code',
            label: 'Código Técnico',
            requiredErrorMsg: 'El código es requerido'
        },
        description: {
            name: 'description',
            label: 'Descripción'
        },
        apiVersion: {
            name: 'apiVersion',
            label: 'Versión de API'
        },
        currency: {
            name: 'currency',
            label: 'Moneda'
        },
        inputPrice: {
            name: 'inputPrice',
            label: 'Costo Input'
        },
        outputPrice: {
            name: 'outputPrice',
            label: 'Costo Output'
        },
        cachePrice: {
            name: 'cachePrice',
            label: 'Costo Caché'
        },
        contextWindow: {
            name: 'contextWindow',
            label: 'Ventana de Contexto (Tokens)'
        },
        maxOutputTokens: {
            name: 'maxOutputTokens',
            label: 'Tokens Máximos Salida'
        },
        sortOrder: {
            name: 'sortOrder',
            label: 'Orden'
        }
    }
}
